import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import "../../assets/scss/theme-base/ModelAddConstruction.css";
import { Paginator } from "primereact/paginator";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Intersection from "../Plan/intersection";
import FormatDate from "../Report/FormatDate";
import { DataTable } from "primereact/datatable";
import { Image } from "primereact/image";
import { statusFilterTemplate } from "../../constants/status";
import { QuantityTemplate, statusTemplate } from "../../components/utils";
import { formatDate } from "../Plan/ModalShowPlan";

const defaultImageUrl = "https://static.thenounproject.com/png/1269202-200.png";

export const imageTemplate = (rowData) => {
    return (
        <Image
            src={`${rowData?.categoryImage}` || defaultImageUrl}
            alt="Category Image"
            imageStyle={{ borderRadius: "20%", width: "40px", height: "40px" }}
            preview
            onError={(e) => (e.target.src = defaultImageUrl)}
        />
    );
};
export const teamImageTemplate = (rowData) => {
    return rowData.teamImage ? (
        <Image
            src={`${rowData?.teamImage}` || defaultImageUrl}
            alt="Category Image"
            imageStyle={{ borderRadius: "20%", width: "40px", height: "40px" }}
            preview
            onError={(e) => (e.target.src = defaultImageUrl)}
        />
    ) : (
        <></>
    );
};

const ModalFilterCategoryProduction = ({ visible, onHide, data }) => {
    const [dialogLocationVisible, setDialogLocationVisible] = useState(false);
    const [selectFactoryCode, setSelectFactoryCode] = useState(null);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);

    const handleTeamProgress = (rowData) => {
        setSelectFactoryCode(rowData.factoryCode);
        setDialogLocationVisible(true);
    };
    const onPageChange = (event) => {
        const newFirst = event.first;
        const newRows = event.rows;

        setFirst(newFirst);
        setRows(newRows);
    };

    const paginatedData = data?.slice(first, first + rows);

    return (
        <Dialog
            visible={visible}
            onHide={() => {
                setFirst(0);
                onHide();
            }}
            className="responsive-dialog"
            header="Lọc theo hạng mục"
            modal
            style={{ width: "80vw", height: "80vh" }}
        >
            <div className="p-3 border-round-md">
                <div>
                    <DataTable
                        rowClassName="custom-row-class-factory-inprogress"
                        size="small"
                        value={paginatedData}
                        emptyMessage="Không có dữ liệu"
                        scrollable
                        scrollHeight="550px"
                    >
                        <Column
                            header="STT"
                            body={(rowData, options) => (
                                <div className="text-center">
                                    {first + options.rowIndex + 1}
                                </div>
                            )}
                            frozen={window.innerWidth > 768}
                            style={{ width: "3%", minWidth: "60px" }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Tên công trình"
                            field="Building.name"
                            filter
                            frozen={window.innerWidth > 768}
                            filterPlaceholder="Tìm kiếm tên công trình"
                            style={{ width: "5%", minWidth: "200px" }}
                        ></Column>
                        <Column
                            header="Mã ĐH"
                            field="orderCode"
                            filter
                            frozen={window.innerWidth > 768}
                            filterPlaceholder="Tìm kiếm mã đơn hàng"
                            style={{ width: "6%", minWidth: "100px" }}
                        ></Column>
                        <Column
                            header="Mã nhà máy"
                            field="factoryCode"
                            filter
                            frozen
                            filterPlaceholder="Tìm kiếm mã nhà máy"
                            style={{ width: "8%", minWidth: "150px" }}
                        ></Column>
                        <Column
                            header="Hạng mục"
                            field="categoryName"
                            filter
                            frozen={window.innerWidth > 768}
                            filterPlaceholder="Tìm kiếm hạng mục"
                            style={{
                                width: "6%",
                                minWidth: "200px",
                                lineHeight: "1.5",
                            }}
                        ></Column>
                        <Column
                            header="Hình ảnh"
                            body={imageTemplate}
                            style={{
                                width: "8%",
                                height: "55px",
                                minWidth: "70px",
                            }}
                            frozen={window.innerWidth > 768}
                            align={"center"}
                        ></Column>

                        <Column
                            header="SL"
                            field="quantity"
                            style={{ width: "3%", minWidth: "60px" }}
                            alignHeader={"center"}
                            body={QuantityTemplate}
                            align={"center"}
                        ></Column>
                        <Column
                            header="ĐVT"
                            field="unit"
                            filter
                            filterPlaceholder="Tìm kiếm đơn vị tính"
                            style={{ width: "3%", minWidth: "60px" }}
                        ></Column>
                        <Column
                            header="Mã SP"
                            field="productCode"
                            filter
                            filterPlaceholder="Tìm kiếm mã sản phẩm"
                            style={{ width: "5%", minWidth: "150px" }}
                        ></Column>

                        <Column
                            header="Kế hoạch hoàn thành"
                            field="intendFinishDate"
                            sortable
                            body={(rowData) =>
                                formatDate(rowData.intendFinishDate)
                            }
                            style={{ width: "8%", minWidth: "120px" }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>

                        <Column
                            header="Trạng thái"
                            field="status"
                            filter
                            filterElement={statusFilterTemplate}
                            pt={{
                                filterButtonbar: {
                                    className: "hidden",
                                },
                            }}
                            body={statusTemplate}
                            style={{ width: "12%", minWidth: "150px" }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Ngày ra BOM"
                            style={{ width: "8%", minWidth: "150px" }}
                            field="bomProductionDate"
                            filter
                            filterPlaceholder="Tìm kiếm ngày ra BOM"
                            body={(rowData) =>
                                formatDate(rowData.bomProductionDate)
                            }
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Ngày bắt đầu SX"
                            style={{ width: "8%", minWidth: "150px" }}
                            field="startedDate"
                            filter
                            filterPlaceholder="Tìm kiếm ngày bắt đầu"
                            body={(rowData) => formatDate(rowData.startedDate)}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                        <Column
                            header="Hoàn thành thực tế"
                            style={{ width: "8%", minWidth: "165px" }}
                            field="endedDate"
                            filter
                            filterPlaceholder="Tìm kiếm ngày hoàn thành"
                            body={(rowData) => formatDate(rowData.endedDate)}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>

                        <Column
                            header="Ghi chú"
                            field="productNote"
                            style={{ width: "6%", minWidth: "150px" }}
                        ></Column>

                        <Column
                            header="Định vị"
                            body={(rowData) => (
                                <div className="text-center">
                                    <Button
                                        onClick={() =>
                                            handleTeamProgress(rowData)
                                        }
                                        icon="pi pi-map-marker"
                                        rounded
                                        text
                                        severity="secondary"
                                        aria-label="Bookmark"
                                        style={{ color: "black" }}
                                    />
                                    <p>{rowData.teamWorking}</p>
                                </div>
                            )}
                            style={{
                                width: "15%",
                                minWidth: "100px",
                            }}
                            alignHeader={"center"}
                            align={"center"}
                        ></Column>
                    </DataTable>
                    <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={data?.length}
                        rowsPerPageOptions={[10, 20, 30, 100, 200, 500]}
                        onPageChange={onPageChange}
                    />

                    <Intersection
                        visible={dialogLocationVisible}
                        onHide={() => setDialogLocationVisible(false)}
                        factoryCode={selectFactoryCode}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default ModalFilterCategoryProduction;
